(function () {
  'use strict';

  function initSwatchArrows(card) {
    var wrap = card.querySelector('.swatch-scroll-wrap');
    if (!wrap) return;
    var track = wrap.querySelector('.linked-product-swatches');
    var prevBtn = wrap.querySelector('.swatch-arrow--prev');
    var nextBtn = wrap.querySelector('.swatch-arrow--next');
    if (!track || !prevBtn || !nextBtn) return;

    var currentOffset = 0;

    function getMaxOffset() {
      var items = track.querySelectorAll('.card-color-swatch--inner');
      if (!items.length) return 0;
      var lastItem = items[items.length - 1];
      var lastRight = lastItem.getBoundingClientRect().right;
      var wrapRight = wrap.getBoundingClientRect().right;
      // How far the last item extends past the wrap's right edge,
      // plus currentOffset to get the total scrollable distance
      return Math.max(0, (lastRight - wrapRight) + currentOffset);
    }

    function applyOffset(offset) {
      currentOffset = Math.max(0, Math.min(offset, getMaxOffset()));
      track.style.transform = currentOffset > 0 ? 'translateX(-' + currentOffset + 'px)' : '';
      updateArrows();
    }

    function updateArrows() {
      var maxOffset = getMaxOffset();
      prevBtn.classList.toggle('is-visible', currentOffset > 2);
      nextBtn.classList.toggle('is-visible', currentOffset < maxOffset - 2);
    }

    var scrollAmount = 60;
    prevBtn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      applyOffset(currentOffset - scrollAmount);
    });
    nextBtn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      applyOffset(currentOffset + scrollAmount);
    });

    // Touch swipe on the track itself
    var touchStartX = 0;
    var touchStartOffset = 0;
    track.addEventListener('touchstart', function (e) {
      touchStartX = e.touches[0].clientX;
      touchStartOffset = currentOffset;
    }, { passive: true });
    track.addEventListener('touchmove', function (e) {
      var dx = touchStartX - e.touches[0].clientX;
      applyOffset(touchStartOffset + dx);
    }, { passive: true });

    window.addEventListener('resize', updateArrows, { passive: true });

    updateArrows();
    requestAnimationFrame(updateArrows);
  }

  function initCard(card) {
    var swatches = card.querySelectorAll('.linked-product-swatches .card-color-swatch--inner');
    if (!swatches.length) return;

    // The main product image to swap
    var mainImg = card.querySelector('img[data-product-card-image]');

    // Track the currently committed image src/srcset so hover can restore it
    var committedSrc = null;
    var committedSrcset = null;

    swatches.forEach(function (swatchEl) {
      var link = swatchEl.querySelector('button.card-color-swatch-input');
      if (!link) return;

      // ── Hover: preview image only (on parent div, so disabled/unavailable buttons still work) ──
      swatchEl.addEventListener('mouseenter', function () {
        var imageUrl = swatchEl.dataset.linkedImageUrl;
        if (!mainImg || !imageUrl) return;
        if (!mainImg.dataset.originalSrc) {
          mainImg.dataset.originalSrc = mainImg.currentSrc || mainImg.src;
          mainImg.dataset.originalSrcset = mainImg.srcset || '';
        }
        mainImg.srcset = '';
        mainImg.src = imageUrl;
      });

      swatchEl.addEventListener('mouseleave', function () {
        if (!mainImg) return;
        var restoreSrc = committedSrc || mainImg.dataset.originalSrc;
        var restoreSrcset = committedSrcset !== null ? committedSrcset : (mainImg.dataset.originalSrcset || '');
        if (restoreSrc) {
          mainImg.srcset = restoreSrcset;
          mainImg.src = restoreSrc;
        }
      });

      link.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var variantUrl      = swatchEl.dataset.variantUrl;
        var imageUrl        = swatchEl.dataset.linkedImageUrl;
        var variantPrice    = swatchEl.dataset.variantPrice;
        var compareValue    = parseInt(swatchEl.dataset.variantCompareAtPriceValue || '0', 10);
        var priceValue      = parseInt(swatchEl.dataset.variantPriceValue || '0', 10);
        var productTitle    = swatchEl.dataset.productTitle;
        var productTagline  = swatchEl.dataset.productTagline || '';
        var productAudience = swatchEl.dataset.productAudience || '';

        // ── Active swatch ──────────────────────────────────────────────
        card.querySelectorAll('.linked-product-swatches button.card-color-swatch-input').forEach(function (btn) {
          btn.classList.remove('swatch-selected');
        });
        link.classList.add('swatch-selected');

        // ── Image swap (commit) ────────────────────────────────────────
        if (mainImg && imageUrl) {
          if (!mainImg.dataset.originalSrc) {
            mainImg.dataset.originalSrc = mainImg.currentSrc || mainImg.src;
            mainImg.dataset.originalSrcset = mainImg.srcset || '';
          }
          mainImg.srcset = '';
          mainImg.src = imageUrl;
          committedSrc = imageUrl;
          committedSrcset = '';
        }

        // ── Card links ─────────────────────────────────────────────────
        card.querySelectorAll('[data-product-card-link]').forEach(function (cardLink) {
          cardLink.setAttribute('href', variantUrl);
        });
        card.dataset.productUrl = variantUrl;

        // ── Title ──────────────────────────────────────────────────────
        if (productTitle) {
          var titleLink = card.querySelector('.product-grid--title a');
          if (titleLink) titleLink.textContent = productTitle;
        }

        // ── Tagline ────────────────────────────────────────────────────
        var taglineEl = card.querySelector('.product-grid--tagline');
        if (taglineEl) {
          taglineEl.textContent = productTagline;
          taglineEl.style.display = productTagline ? '' : 'none';
        }

        // ── Audience label ─────────────────────────────────────────────
        var audienceEl = card.querySelector('.product-grid--audience-label');
        if (audienceEl) {
          audienceEl.textContent = productAudience;
          audienceEl.style.display = productAudience ? '' : 'none';
        }

        // ── Badge ──────────────────────────────────────────────────────
        var badgeWrapper = card.querySelector('[data-product-card-badge]');
        if (badgeWrapper) badgeWrapper.innerHTML = swatchEl.dataset.badgeHtml || '';

        // ── Price ──────────────────────────────────────────────────────
        var priceEl = card.querySelector('.product-grid--price');
        if (priceEl && variantPrice) {
          var saleBlock    = priceEl.querySelector('.product-price--sale');
          var regularBlock = priceEl.querySelector('.product-price--regular');
          var salePriceSpan    = priceEl.querySelector('.price--sale-price');
          var regularPriceSpan = priceEl.querySelector('.price--regular-price');
          var compareSpan      = priceEl.querySelector('.price--compare-at-price');

          if (compareValue > priceValue && compareValue > 0) {
            // Sale: update sale price + compare-at price, show sale block
            if (salePriceSpan) salePriceSpan.textContent = variantPrice;
            if (compareSpan) {
              // Preserve the visually-hidden child, update only the price text node
              var textNode = Array.from(compareSpan.childNodes).find(function (n) {
                return n.nodeType === 3 && n.textContent.trim();
              });
              if (textNode) {
                textNode.textContent = swatchEl.dataset.variantCompareAtPrice;
              } else {
                compareSpan.appendChild(document.createTextNode(swatchEl.dataset.variantCompareAtPrice));
              }
            }
            if (saleBlock) saleBlock.classList.remove('hidden');
            if (regularBlock) regularBlock.classList.add('hidden');
          } else {
            // Regular: update regular price, show regular block
            if (regularPriceSpan) regularPriceSpan.textContent = variantPrice;
            if (regularBlock) regularBlock.classList.remove('hidden');
            if (saleBlock) saleBlock.classList.add('hidden');
          }
        }
      });
    });
    initSwatchArrows(card);
  }

  function initFilterDrawer() {
    document.querySelectorAll('collection-filtering-form').forEach(function (filterForm) {
      // Intercept input events (capturing, so we run before the form's listener)
      // and swallow them — filters only apply when Show Results is clicked.
      filterForm.addEventListener('input', function (e) {
        if (!filterForm._applyingFilters) {
          e.stopPropagation();
        }
      }, true);

      // Prevent theme's onDropDownBlur (document click handler) from closing
      // other facets when the user clicks inside the drawer.
      filterForm.addEventListener('click', function (e) {
        e.stopPropagation();
      });

      // Keep sibling facets open when one is opened/closed.
      filterForm.querySelectorAll('details.facets__disclosure').forEach(function (details) {
        var summary = details.querySelector('summary');
        if (!summary) return;
        summary.addEventListener('click', function () {
          var openSiblings = Array.from(
            filterForm.querySelectorAll('details.facets__disclosure[open]')
          ).filter(function (d) { return d !== details; });
          setTimeout(function () {
            openSiblings.forEach(function (d) { d.open = true; });
          }, 0);
        });
      });
    });

    // Show Results: apply the current form state then close the drawer.
    document.querySelectorAll('[data-filter-show-results]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var filterForm = document.querySelector('collection-filtering-form');
        if (filterForm) {
          var form = filterForm.querySelector('form');
          if (form) {
            filterForm._applyingFilters = true;
            form.dispatchEvent(new Event('input', { bubbles: true }));
            filterForm._applyingFilters = false;
          }
        }
        var closeBtn = document.querySelector('[data-drawer-close-btn]');
        if (closeBtn) closeBtn.click();
      });
    });
  }

  function initResizeFix() {
    var resizeTimer;
    var desktopMq = window.matchMedia('(min-width: 768px)');
    window.addEventListener('resize', function () {
      document.querySelectorAll('collection-filtering-form').forEach(function (form) {
        form.style.transition = 'none';
        form.style.transform = desktopMq.matches ? 'none' : 'translateX(-100%)';
      });
      // Suppress nav drawer transition during resize
      document.querySelectorAll('#NavDrawer').forEach(function (nav) {
        nav.style.transition = 'none';
      });
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        document.querySelectorAll('collection-filtering-form').forEach(function (form) {
          form.style.transition = '';
          form.style.transform = '';
        });
        document.querySelectorAll('#NavDrawer').forEach(function (nav) {
          nav.style.transition = '';
        });
      }, 150);
    });
  }

  function initSwatchWheelForward() {
    // Intercept wheel events in the CAPTURE phase, before Swiper's mousewheel
    // module (bubble phase) can call preventDefault on vertical scrolls.
    // Vertical scroll is forwarded to the page; horizontal passes through to Swiper.
    document.querySelectorAll('.color-swatch--block').forEach(function (block) {
      block.addEventListener('wheel', function (e) {
        if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) {
          e.stopPropagation(); // prevent Swiper's bubble-phase handler from firing
          e.preventDefault();
          window.scrollBy({ top: e.deltaY, behavior: 'auto' });
        }
      }, { passive: false, capture: true });
    });
  }

  function init() {
    document.querySelectorAll('product-card[data-original-product-id]').forEach(initCard);
    initFilterDrawer();
    initResizeFix();
    initSwatchWheelForward();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
